module.exports = __webpack_public_path__ + "static/media/EulsScepterofDivinity.6172ac2e.png";